import React, { useState } from 'react';
import { normalizeDate } from '../utils/dateUtils.ts';

interface MonthlyIndicatorFormProps {
  onSubmit: (payload: { month: string; value: number }) => Promise<void>;
}

const MonthlyIndicatorForm: React.FC<MonthlyIndicatorFormProps> = ({ onSubmit }) => {
  const [month, setMonth] = useState(() => {
    const now = new Date();
    const monthValue = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    return monthValue;
  });
  const [value, setValue] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setSaving(true);
    try {
      const normalizedMonth = normalizeDate(`${month}-01`).slice(0, 7);
      const normalizedValue = Number(value.replace(',', '.'));
      if (!Number.isFinite(normalizedValue)) {
        console.error('Valor inválido para indicador mensal.');
        return;
      }
      await onSubmit({ month: normalizedMonth, value: normalizedValue });
      setValue('');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="indicator-form" onSubmit={handleSubmit}>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="indicator-month">Mês *</label>
          <input
            type="month"
            id="indicator-month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="indicator-value">Valor *</label>
          <input
            type="text"
            id="indicator-value"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            required
            placeholder="Valor"
          />
        </div>
      </div>
      <div className="form-actions">
        <button type="submit" className="primary-button" disabled={saving}>
          {saving ? 'Salvando...' : 'Registrar'}
        </button>
      </div>
    </form>
  );
};

export default MonthlyIndicatorForm;
